module.exports = __webpack_public_path__ + "static/media/HomeBackground.fa3631e4.png";